import { DataRow } from '@23degrees/shared-code/models';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

export class InlineVariable {
  deltaOp: DeltaInsertOp;
  variableName?: string;

  protected constructor(deltaOp: DeltaInsertOp) {
    this.deltaOp = deltaOp;
  }

  static create = (deltaOp: DeltaInsertOp) => {
    return new InlineVariable(deltaOp);
  };

  public resolveVariables = (dataContext: DataRow, fallbackStr = 'No data available'): string => {
    const options = this.deltaOp.insert.value;
    const { variableName } = options;
    const data = dataContext[variableName] ?? '';
    // assure return type is a string;
    return `${data}`;
  };
}
